import Vue from 'vue'
//lib para conversão de datas
window.moment = require('moment');
window.moment.locale('pt-br');

Vue.filter('data', function(date){
  if (date)
    return moment(date).format('DD-MM-YYYY')
  else
    return ''
})

Vue.filter('dataHora', function(date){
    if (date)
      return moment(date).format('DD-MM-YYYY, H:mm:ss')
    else
      return ''
})

Vue.filter('dataHoraCurta', function(date){
    if (date)
      return moment(date).format('DD-MM-YYYY, H:mm')
    else
      return ''
})

Vue.filter('hora', function(date){
    if (date)
      return moment(date).format('H:mm')
    else
      return ''
})



// WEBPACK FOOTER //
// ./resources/assets/js/filters/date.js